import React, { useEffect } from "react";
import { ProductSelectorProps } from "../../websiteTemplates/Default/ProductSelector";
import GetComponent from "../../websiteTemplates/_GetComponent";
import { useSalesChannel } from "../../../context/SalesChannelContext";
import { ProductType } from "../../../types";
import { gtmHandleDataLayer } from "../../../services/gtm";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { ClientAction } from "../../../store/order";

export default function SingleProductDetail(defaultProduct: ProductType) {
    let props: ProductSelectorProps =
        { defaultProduct: defaultProduct, slug: "" }
    const salesChannel = useSalesChannel();

    const currencyCode = useSelector((state: RootState) => state.currencyCode.selectedCurrencyCode?.currencyCode);

    useEffect(() => {
        const data = {
            action: ClientAction.viewItem,
            parsed: {
                product: defaultProduct,
            }
        }
        gtmHandleDataLayer(data, salesChannel, currencyCode || "");
    }, []);

    return <GetComponent component="SingleProductDetail" template={salesChannel?.websiteTemplate} props={props} />
}
